var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0647 81.4281H92.8574V89.2857H7.14307V81.4281H14.9357V14.6406C14.9357 13.5993 15.346 12.6006 16.0762 11.8643C16.8064 11.128 17.7969 10.7143 18.8296 10.7143H81.1659C82.1986 10.7143 83.189 11.128 83.9193 11.8643C84.6495 12.6006 85.0598 13.5993 85.0598 14.6406L85.0647 81.4281ZM34.4149 46.0712V53.9288H46.1014V46.0712H34.4149ZM34.4149 30.3559V38.2135H46.1014V30.3559H34.4149ZM34.4149 61.7815V69.6391H46.1014V61.7865L34.4149 61.7815ZM53.8941 61.7815V69.6391H65.5806V61.7865L53.8941 61.7815ZM53.8941 46.0662V53.9239H65.5806V46.0712L53.8941 46.0662ZM53.8941 30.3509V38.2135H65.5806V30.3559L53.8941 30.3509Z",
    fill: "#4D3ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBuilding);
export default __webpack_public_path__ + "static/media/about-building.7b0e5081f2e8039e66d7642746428314.svg";
export { ForwardRef as ReactComponent };